// extracted by mini-css-extract-plugin
module.exports = {"title":"layout-row-content-module--title--22pyD"};